<!-- -->
<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import _ from 'lodash'
import { useNotification } from "@kyvg/vue3-notification"
import ModalBox from './ModalBox.vue'
import IconBase from '@/components/icon/IconBase.vue'
import FormButton from '@/components/Atoms/FormButton.vue'
import ShowcaseThumb from '../Showcase/ShowcaseThumb.vue'
import IconChevronLeft from '../icon/IconChevronLeft.vue'

const { notify } = useNotification()

// Props
const props = defineProps({
  showcase: {
    type: Object,
    required: true,
  },
  publishesStatus: {
    type: Boolean,
  },
  sortedStream: {
    type: Object,
    required: true,
  },
  publish : {
    type: Function,
  }
})

// Model
const isVisible = defineModel('isVisible')

// Hooks
onMounted(() => {

})

</script>

<template>
  <ModalBox v-model="isVisible" @close="closeModal" fullscreen hide-header>
    <div class="bg-white h-screen overflow-y-auto p-6">
      <header class="flex items-center justify-between mb-6">
        <FormButton size="sm" type="link" class="!text-surface-1" @click="isVisible = false">
          <IconBase>
            <IconChevronLeft />
          </IconBase>
          Back to Dashboard
        </FormButton>
        <FormButton size="sm" :disabled="!publishesStatus" @click="publish">
          Publish
        </FormButton>
      </header>
      <section class="h-[40vh] bg-cover bg-center -mx-6"
        :style="((showcase?.settings?.backgroundUrl) ? 'background-image: url(https://assets.castr.io/showcaseImages/' + showcase?.settings?.backgroundUrl + ')' : '')">
        <div class="flex flex-col justify-center items-center">
          <img class="size-16 self-start" :src="'https://assets.castr.io/showcaseImages/' + showcase.settings.logoUrl"
            v-if="showcase?.settings?.logoUrl" alt="">
          <h2 v-if="showcase?.settings?.title" class="text-xl lg:text-7xl drop-shadow-lg mb-6">{{ showcase.settings.title }}</h2>
          <p class="text-lg" v-if="showcase?.settings?.description">{{ showcase.settings.description
            }}</p>
          <FormButton size="lg" class="mt-6 !bg-[darkturquoise]">Start Watching Videos</FormButton>
        </div>
      </section>
      <section class="">
        <p class="">{{ showcase?.vods.length }} videos, {{ showcase?.streams.length
          }} live streams</p>
        <ul class="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <li class="bg-black rounded-lg aspect-video flex flex-col" v-for="stream in sortedStream" :key="stream._id">
            <!-- <div v-if="streamFilter(stream)"> -->
            <!-- {{stream}} -->
            <showcase-thumb :stream="stream" :is-thumb="true"></showcase-thumb>
            <h4 class="text-tiny mt-auto !px-2 truncate" v-if="stream.type">{{ stream.name }}</h4>
            <p class="text-tiny mt-auto !px-2 !pb-2 truncate" v-else>{{ stream.fileName }}</p>
            <!-- </div> -->
          </li>
        </ul>
      </section>
    </div>
  </ModalBox>
</template>
